import React from 'react';

const Integrations = ({
  publicCalendarLink,
  copyPublicCalendarLink,
  isPublicCalendarExpanded,
  setPublicCalendarExpanded,
  isGoogleSyncExpanded,
  setGoogleSyncExpanded,
  handleSyncClick,
  handleRemoveSync,
  googleAccounts,
  isCalendarSubscribeExpanded,
  setCalendarSubscribeExpanded,
  calendarFeedUrl,
  feedCopied,
  setFeedCopied,
}) => {
  return (
    <div className="integrations-container">

      {/* Public Booking Link */}
      <div className="public-calendar-section">
        <h3
          className="collapsible-title"
          onClick={() => setPublicCalendarExpanded(!isPublicCalendarExpanded)}
        >
          <span>Public booking link</span>
          <span>{isPublicCalendarExpanded ? '▴' : '▾'}</span>
        </h3>
        {isPublicCalendarExpanded && (
          <div className="survey-content">
            <div className="input-group">
              <input
                type="text"
                readOnly
                value={publicCalendarLink}
                className="public-calendar-input"
                onClick={(e) => e.target.select()}
              />
              <button onClick={copyPublicCalendarLink} className="copy-link-btn">
                Copy link
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Google Calendar Sync */}
      <div className="sync-calendar-section">
        <h3
          className="collapsible-title"
          onClick={() => setGoogleSyncExpanded(!isGoogleSyncExpanded)}
        >
          <span>Google Calendar sync</span>
          <span>{isGoogleSyncExpanded ? '▴' : '▾'}</span>
        </h3>
        {isGoogleSyncExpanded && (
          <div className="survey-content">
            {googleAccounts && googleAccounts.length > 0 && (
              <div className="account-info" style={{ marginBottom: '1rem' }}>
                <p><strong>Connected:</strong> {googleAccounts.map(a => a.email).join(', ')}</p>
              </div>
            )}
            <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
              <button onClick={handleSyncClick} className="sync-btn">
                Connect Google Calendar
              </button>
              <button onClick={handleRemoveSync} className="remove-sync-btn">
                Remove sync
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Subscribe to Calendar */}
      <div className="sync-calendar-section">
        <h3
          className="collapsible-title"
          onClick={() => setCalendarSubscribeExpanded(!isCalendarSubscribeExpanded)}
        >
          <span>Subscribe to calendar</span>
          <span>{isCalendarSubscribeExpanded ? '▴' : '▾'}</span>
        </h3>
        {isCalendarSubscribeExpanded && (
          <div className="survey-content">
            <p className="subscribe-description">
              Subscribe to your AirFlyp calendar from Outlook, Apple Calendar, or any app that supports calendar feeds. Events sync automatically.
            </p>
            <div className="subscribe-feed-url">
              <input
                type="text"
                readOnly
                value={calendarFeedUrl}
                className="settings-input"
                onClick={(e) => e.target.select()}
              />
              <button
                className="copy-feed-btn"
                onClick={() => {
                  navigator.clipboard.writeText(calendarFeedUrl);
                  setFeedCopied(true);
                  setTimeout(() => setFeedCopied(false), 2000);
                }}
              >
                {feedCopied ? 'Copied ✓' : 'Copy URL'}
              </button>
            </div>
            <div className="subscribe-instructions">
              <div className="subscribe-instruction-card">
                <strong>Outlook / Microsoft 365</strong>
                <p>Settings → Calendar → Shared calendars → Subscribe from web → Paste URL</p>
              </div>
              <div className="subscribe-instruction-card">
                <strong>Apple Calendar (Mac)</strong>
                <p>File → New Calendar Subscription → Paste URL → Subscribe</p>
              </div>
              <div className="subscribe-instruction-card">
                <strong>Apple Calendar (iPhone / iPad)</strong>
                <p>Settings → Calendar → Accounts → Add Account → Other → Add Subscribed Calendar</p>
              </div>
              <div className="subscribe-instruction-card">
                <strong>Google Calendar</strong>
                <p>Settings → Add calendar → From URL → Paste URL</p>
              </div>
            </div>
          </div>
        )}
      </div>

    </div>
  );
};

export default Integrations;
